module.exports = __webpack_public_path__ + "c54f1d288c627f83352371ad7df86f1c.pdf";